/* 01 · HEADER — sections/nhp-header.liquid + sections/nhp-mobile-bar.liquid. Deferred. */
(function () {
  var root = document.documentElement;

  /* Full-screen nav: native <dialog> gives focus trap, Esc and inert page for free. */
  var nav = document.querySelector('[data-nhp-nav]');
  var menuBtn = document.querySelector('[data-nhp-menu]');
  var closeNav = function () { if (nav && nav.open) nav.close(); };
  if (nav && menuBtn && nav.showModal) {
    /* the storm: two strikes on open (the Leader's lightning), then a distant flash every 8–14s while it
       stays open. Never more than two flashes a second (WCAG 2.3.1); nothing under reduced motion. */
    var calm = matchMedia('(prefers-reduced-motion: reduce)').matches;
    var distant = null;
    function strike(cls) {
      nav.classList.remove(cls);
      void nav.offsetWidth;   // restart the animation
      nav.classList.add(cls);
    }
    function rumble() {
      distant = setTimeout(function () {
        if (!nav.open) return;
        strike('is-distant');
        rumble();
      }, 8000 + Math.random() * 6000);
    }
    /* HE GETS CLOSER: the 1st open this visit he's far off in the fog; the 2nd he's RIGHT THERE (the close-up
       hood, lit by the strike); the 3rd on, gone. Jay: most people open the menu once or twice — the close-up
       must land by the second. Under reduced motion he just stands far off. */
    var STEPS = [1, 4, 5];   // opens → the CSS steps (1 far · 4 the hood · 5 gone)
    function nearer() {
      var n = 1;
      if (!calm) {
        try { n = Math.min(STEPS.length, (Number(sessionStorage.getItem('nhpNear')) || 0) + 1); sessionStorage.setItem('nhpNear', n); } catch (e) {}
      }
      nav.setAttribute('data-near', STEPS[n - 1]);
    }
    menuBtn.addEventListener('click', function () {
      nearer();
      nav.showModal();
      root.classList.add('nhp-nav-open');
      menuBtn.setAttribute('aria-expanded', 'true');
      if (!calm) { nav.classList.remove('is-distant'); strike('is-storm'); clearTimeout(distant); rumble(); }
    });

    /* Cleanup runs HERE, not in a 'close' listener. dialog.close() fires no close event in this
       store (something on the page replaces HTMLDialogElement.prototype.close), so the listener
       never ran: html kept .nhp-nav-open, which sets overflow: hidden, and the page was left
       unscrollable after the menu closed. Verified 2026-09-20: 0 close events from a direct
       showModal()/close() test. The listener below stays as a backstop for a native close. */
    closeNav = function (scrollTo) {
      if (nav.open) nav.close();
      clearTimeout(distant);
      nav.classList.remove('is-storm', 'is-distant');
      root.classList.remove('nhp-nav-open');
      menuBtn.setAttribute('aria-expanded', 'false');
      // scrolling only works once the lock above is off
      if (scrollTo) scrollTo.scrollIntoView();
      else menuBtn.focus();
    };
    nav.addEventListener('close', function () {
      root.classList.remove('nhp-nav-open');
      menuBtn.setAttribute('aria-expanded', 'false');
    });

    nav.querySelector('[data-nhp-nav-close]').addEventListener('click', function () { closeNav(); });
    // Native Esc-to-close isn't reliable everywhere; close explicitly.
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && nav.open) closeNav();
    });

    /* A link to a section on THIS page only changes the hash, so the menu would sit open over a
       page that cannot scroll behind a modal — tapping NOW SHOWING looked like nothing happened
       (Jay, 2026-09-20). Close the menu, then jump to the section ourselves. */
    nav.addEventListener('click', function (e) {
      var a = e.target.closest('a[href]');
      if (!a) return;
      var url = new URL(a.href, location.href);
      if (url.pathname !== location.pathname || url.search !== location.search || !url.hash) { closeNav(); return; }
      var target = document.querySelector(url.hash);
      if (!target) { closeNav(); return; }
      e.preventDefault();
      if (location.hash !== url.hash) history.pushState(null, '', url.hash);
      closeNav(target);
    });
  }

  /* BOX OFFICE: open Skeleton's drawer via NNCart (main.js); plain /cart link if it's missing. */
  document.querySelectorAll('[data-nhp-cart]').forEach(function (el) {
    el.addEventListener('click', function (e) {
      if (!window.NNCart) return;
      e.preventDefault();
      closeNav();
      window.NNCart.open();
    });
  });

  /* Jar cap: main.js rewrites [data-cart-count]; mirror it to data-count for the fill. */
  var cart = document.querySelector('.nhp-hdr__cart');
  var count = cart && cart.querySelector('[data-cart-count]');
  if (count) {
    new MutationObserver(function () {
      cart.setAttribute('data-count', parseInt(count.textContent, 10) || 0);
    }).observe(count, { childList: true, characterData: true, subtree: true });
  }

  if (!('IntersectionObserver' in window)) return;

  /* Shrink after 80px of scroll — no scroll listener. */
  var hdrSentinel = document.querySelector('[data-nhp-hdr-sentinel]');
  if (hdrSentinel) {
    new IntersectionObserver(function (entries) {
      var e = entries[0];
      root.classList.toggle('nhp-hdr-shrunk', !e.isIntersecting && e.boundingClientRect.top < 0);
    }).observe(hdrSentinel);
  }

  /* Mobile bar: shown once the hero (or the first viewport) has scrolled away. */
  var bar = document.querySelector('[data-nhp-mbar]');
  var target = document.querySelector('[data-nhp-hero]') || document.querySelector('[data-nhp-mbar-sentinel]');
  if (bar && target) {
    new IntersectionObserver(function (entries) {
      var e = entries[0];
      bar.classList.toggle('is-shown', !e.isIntersecting && e.boundingClientRect.top < 0);
    }).observe(target);
  }
})();

/* ---- 01 · THE SHOWTIMES BOARD --------------------------------------------------------------
   One message holds still for HOLD_MS, then the film splices to the next. No scrolling: a moving
   line is what you can't read, and hover-to-pause doesn't exist on a phone. The shipping message
   rewrites itself from Skeleton's cart (the `nhp:cart` event main.js dispatches from render()).
   All copy comes from section settings — nothing brand-voiced is hardcoded here. ---- */
(function () {
  var board = document.querySelector('[data-nhp-board]');
  if (!board) return;
  var msgs = [].slice.call(board.querySelectorAll('[data-nhp-msg]'));
  if (msgs.length < 2) return;   // nothing to cut to

  var hold = board.querySelector('[data-nhp-board-hold]');
  var fill = board.querySelector('[data-nhp-board-fill]');
  var ship = board.querySelector('[data-nhp-msg="ship"]');
  var threshold = (parseFloat(board.getAttribute('data-threshold')) || 65) * 100;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var HOLD_MS = 4500, CUT_MS = 250, SWAP_MS = 110;
  var at = 0, paused = false, timer = null, pct = 0;

  function money(c) { return '$' + (c / 100).toFixed(2).replace(/\.00$/, ''); }

  /* The lines are centered in the whole bar, so the usable width is the bar minus a hold button on
     BOTH sides. Copy comes from theme settings and can be any length, so fit it rather than trust a
     magic number: shrink only the lines that overflow, never below 13px. */
  function fit() {
    var reserve = hold ? hold.offsetWidth * 2 : 0;
    var avail = board.clientWidth - reserve;
    if (avail <= 0) return;
    msgs.forEach(function (m) {
      m.style.fontSize = '';
      var natural = parseFloat(window.getComputedStyle(m).fontSize) || 17;
      var w = m.scrollWidth;
      if (w > avail) {
        m.style.fontSize = Math.max(13, Math.floor(natural * (avail / w) * 10) / 10) + 'px';
      }
    });
  }

  function paint() {
    // the creep belongs under the shipping message and nowhere else
    if (fill) fill.style.width = (msgs[at] === ship ? pct : 0) + '%';
  }

  function show(n) {
    msgs[at].classList.remove('is-on');
    at = n;
    msgs[at].classList.add('is-on');
    paint();
  }

  function next() {
    var n = (at + 1) % msgs.length;
    if (reduce) { show(n); return; }
    board.classList.add('is-cut');
    setTimeout(function () { show(n); }, SWAP_MS);
    setTimeout(function () { board.classList.remove('is-cut'); }, CUT_MS);
  }

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(function () {
      fit();   // self-healing: metrics can settle late (webfont, zoom, a settings edit)
      if (!paused && !document.hidden) next();
      schedule();
    }, HOLD_MS);
  }

  if (hold) {
    hold.addEventListener('click', function () {
      paused = !paused;
      hold.setAttribute('aria-pressed', String(paused));
      if (paused) clearTimeout(timer); else schedule();
    });
  }

  document.addEventListener('nhp:cart', function (e) {
    var cart = e.detail || {};
    var total = cart.total_price || 0;
    pct = threshold > 0 ? Math.min(100, (total / threshold) * 100) : 0;
    if (ship) {
      if (!cart.item_count) {
        ship.textContent = ship.getAttribute('data-base');
        pct = 0;
      } else if (total >= threshold) {
        ship.textContent = ship.getAttribute('data-unlocked');
      } else {
        ship.textContent = (ship.getAttribute('data-away') || '').replace('[AMOUNT]', money(threshold - total));
      }
      fit();
    }
    paint();
  });

  fit();
  /* Anton loads with font-display: swap, so the first fit() measures fallback metrics and finds
     nothing to shrink. document.fonts.ready is NOT enough here — it can resolve before the face is
     even requested — so wait on Anton itself. */
  if (document.fonts) {
    if (document.fonts.load) document.fonts.load('17px Anton').then(fit, function () {});
    if (document.fonts.ready) document.fonts.ready.then(fit);
  }
  var rz;
  window.addEventListener('resize', function () { clearTimeout(rz); rz = setTimeout(fit, 150); });

  schedule();
})();
